import React, { Component } from 'react';
import {FormError} from './../FormError';
import { FormGroup, ControlLabel } from 'react-bootstrap';

class CountriesAndStates extends Component {

	constructor(props) {
	  super(props);
	  this.state = {
	    states: [],
      countries: [],
      showStateSelector: 'Select'
	  };   
	}

  setStateSelector = (country) => {    
    if(country !== '' && country !== 'Select') {
      this.setState({showStateSelector: true})
    } else {
      this.setState({showStateSelector: false})
    }
  }  
  
  componentDidMount() {
	  this.loadStates();
	  this.loadCountries();
    this.setStateSelector(this.props.selectedCountry);
	}

  validateResponse = (response) => {
     if (!response.ok) {
       throw Error(response.statusText);
     }
     return response;
   }

  loadStates = () => {
    var states = [];
    return fetch(process.env.REACT_APP_HOST_API_URL  + '/developer/mvc/api/states', {
        headers: {
          'Accept': 'application/json',
        },
        credentials: 'include'
      })
      .then(results => {
        this.validateResponse(results);
        return results.json();
      })
      .then(data => {
    	  states = data.map((state) => {
          return state
        });
        this.setState({
          states: states
        });
      })
      .catch(error => {
        console.log('error trying to fetch states : \n', error);
        return Promise.reject()
      });
    }

    loadCountries = () => {
      var countries = [];
      return fetch(process.env.REACT_APP_HOST_API_URL  + '/developer/mvc/api/countries', {
          headers: {
            'Accept': 'application/json',
          },
          credentials: 'include'
        })
        .then(results => {
          this.validateResponse(results);
          return results.json();
        })
        .then(data => {
          countries = data.map((country) => {
            return country
          });
          this.setState({
            countries: countries
          });
        })
        .catch(error => {
          console.log('error trying to fetch states : \n', error);
          return Promise.reject()
        });
    }

  handleStateChange = (event) => {
    this.setState({
      value: event.target.value
    });
    this.props.updateSelectedState(event.target.value);
  }

  handleNonUSStateChange = (event) => {
    this.setState({
      value: event.target.value
    });
    this.props.updateSelectedNonUSState(event.target.value);
  }

  handleCountryChange = (event) => {
    this.props.updateSelectedCountry(event.target.value);

    this.setState({
      value: event.target.value
    });
    
    this.setStateSelector(event.target.value);
  }

	render () {
    let statesOptionItems = this.state.states.map((state) =>
      <option key={state}>{state}</option>
    );

    let countriesOptionItems = this.state.countries.map((country) =>
      <option key={country}>{country}</option>
    );

    const showStates = this.props.showUSStatesDropdown();
    
    return (
      <div className="row">
        <div className="col-12 col-md-6">
          <div className="row">
            <FormGroup className="form-group col-12 col-md-12">
              <ControlLabel>Country <strong className="text-red"> *</strong></ControlLabel>
              <FormError errorMessage={this.props.countryError} id={"countryError"}/>
              <select className="form-control" 
                onChange={this.handleCountryChange}
                name="country" 
                value={this.props.selectedCountry}
                disabled={this.props.disabled}>
                {countriesOptionItems}
              </select>
            </FormGroup>
            {this.state.showStateSelector === true && 
              <div>
                <FormGroup id="nonUSState" className="col-12 col-md-12" style={{ display: (!showStates ? 'block' : 'none')}}>
                  <ControlLabel>State/Province/Region <strong className="text-red"> *</strong></ControlLabel>
                  <FormError errorMessage={this.props.nonUSStateError} id={"nonUSStateError"}/>
                  <input className="form-control" aria-required="true" name="nonUSState" type="text"
                          value={this.props.selectedNonUSState}
                          onChange={this.handleNonUSStateChange}
                          disabled={this.props.disabled}/>
                </FormGroup>
                <FormGroup className="col-12 col-md-12" style={{ display: (showStates ? 'block' : 'none') }}>
                  <ControlLabel>State<strong className="text-red"> *</strong></ControlLabel>
                  <FormError errorMessage={this.props.usStateError} id={"usStateError"}/>
                  <select className="form-control" onChange={this.handleStateChange} name="usState" aria-required="true" value={this.props.selectedState}
                  disabled={this.props.disabled}>
                        {statesOptionItems}
                  </select>
                </FormGroup>
              </div>
            }
          </div>
        </div>
      </div>
	  )
	}
}

export default CountriesAndStates;



// WEBPACK FOOTER //
// ./src/helper/CountriesAndStates.js